import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";

export const VehicleController = {
    db: getFirestore(Firebase),

    ToFirestoreBoatType: function (data) {
        let updatedData = {
            id: data.id,
            name: data.name,
            value: data.value,
            created_time: data.created_time ?? Timestamp.now(),
            updated_time: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data, res) {
        try {
            const inviteRef = collection(this.db, "vehicles");
            const result = await addDoc(inviteRef, this.ToFirestoreBoatType(data));

            res(result.id);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },


    ListByOwner: async function (ownerUserRef, res) {
        try {
            const querySnapshot = await getDocs(collection(this.db, "vehicles"));
            const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            }));
            // owner_user_ref is a DocumentReference, compare its id with userId
            const newResults = results.filter(
            (vehicle) =>
                vehicle.owner_user_ref &&
                vehicle.owner_user_ref.id === ownerUserRef // ownerUserRef should be userId string
            );
            res(newResults);
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    List: async function (res) {
        const querySnapshot = await getDocs(
            collection(this.db, "vehicles")
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        res(results);
    },
    
    Get: async function (id, res) {
        const docRef = doc(this.db, "vehicles", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            res(docSnap.data());
        } else {
            res(null);
        }
    },

    Delete: async function (id) {
        await deleteDoc(doc(this.db, "vehicles", id));
        return true;
    },
};
